/* eslint-disable jsx-quotes */
/* eslint-disable indent */
import React from 'react';
import 'react-phone-number-input/style.css';
import { connect } from 'react-redux';
import DataTable from '../data-table/data-table';
import ConfirmationModal from '../confirmation-modal/confirmation-modal';
import Modal from '../modal/modal';
import './users.css';
import {
    enrollUser,
    unenrollUser,
    updateEnrollment,
    enrollUserFromRegisterNewUser,
} from '../admin/admin.actions';
import { bindActionCreators } from 'redux';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import MultiSelect from '../multi-select/multi-select';
import moment from 'moment';
import {
    fetchSomeUsers,
    fetchUserEnrollments,
    fetchUsers,
    editNewUserInput,
    toggleFormIsVisible,
    toggleSearchRealmFormIsVisible,
    toggleShitchAddRealmFormIsVisible,
    checkInfoRealmsUser,
    clearcheckInfoRealmsUser,
    clearNewUserForm,
    createNewUser,
    uploadAttach,
    attachmentClassChoose,
    downloadAttach,
    deletingAttach,
    initEditUser,
    finishEditUser,
    createAlertFunc,
    changeRedirectToUsers,
} from './users.actions';
import DatePicker from 'react-datepicker';
import MaskedInput from 'react-input-mask';
import { cpfIsValid, mailIsValid } from '../../utils/user-utils';
import Loader from '../loader-component/loader';
import { SelectFile, readFile } from '../file-uploader/file-uploader';

const userRealmStatus = {
    USER_NOT_EXIST: 'USER_NOT_EXIST',
    USER_READY_TO_REGISTER_REALM: 'USER_READY_TO_REGISTER_REALM',
    USER_ALREADY_REGISTERED_REALM: 'USER_ALREADY_TO_REGISTER_REALM',
};

class Users extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            emailToSearchRealm: '',
            showFilters: false,
            validEmail: true,
            validCpf: true,
            theresClasses: true,
            classesFiltered: [],
            needShowForm: false,
            needShowSearchRealms: false,
            needShowSwichAddRealm: false,
            needShowList: false,
            userRealmState: userRealmStatus.USER_NOT_EXIST,
            initialState : {}
        };
        this.clearState = this.clearState.bind(this);
    }

    componentDidMount() {
        const {
            showSearchRealmUserForm,
            showNewUserForm,
            showShitchAddRealmForm,
        } = this.props;

        const { needShowList } = this.state;
        if (
            !showSearchRealmUserForm &&
            !showNewUserForm &&
            !showShitchAddRealmForm &&
            !needShowList
        ) {
            this.setState({
                needShowForm: false,
                needShowSearchRealms: false,
                needShowSwichAddRealm: false,
                needShowList: true,
            });
        }
    }

    componentDidUpdate(prevProps) {
        const {
            showSearchRealmUserForm,
            showNewUserForm,
            showShitchAddRealmForm,
            realms,
            redirectToUsers,
            changeRedirectToUsers,
            clearNewUserForm,
            toggleFormIsVisible,
            toggleSearchRealmFormIsVisible,
            toggleShitchAddRealmFormIsVisible,
            newUser
        } = this.props;
        const {
            needShowSwichAddRealm,
            needShowSearchRealms,
            needShowList,
            needShowForm,
            userRealmState,
        } = this.state;

        if(prevProps.newUser.userId !== newUser.userId && userRealmState === userRealmStatus.USER_READY_TO_REGISTER_REALM ){
            const {
                nickname = undefined,
                email = undefined,
                cpf = undefined,
                classId = undefined,
                gender = undefined,
                userId,
                phone_number
            } = newUser;
    
            this.setState({ ...this.state, initialState: {
                nickname,
                email,
                cpf,
                classId,
                gender,
                userId,
                phone_number
            }});    
        }

        if (prevProps.redirectToUsers !== redirectToUsers && redirectToUsers) {
            toggleFormIsVisible(false);
            toggleSearchRealmFormIsVisible(false);
            toggleShitchAddRealmFormIsVisible(false);
            changeRedirectToUsers({ withNewValue: false });
            clearNewUserForm();
        }

        if (showSearchRealmUserForm !== prevProps.showSearchRealmUserForm) {
            this.setState({ emailToSearchRealm: '' });
        }

        if (
            realms &&
            realms.hasRealm === false &&
            userRealmState !== userRealmStatus.USER_READY_TO_REGISTER_REALM
        ) {
            this.setState({
                userRealmState: userRealmStatus.USER_READY_TO_REGISTER_REALM,
            });
        } else if (
            realms &&
            realms.hasRealm === true &&
            userRealmState !== userRealmStatus.USER_ALREADY_REGISTERED_REALM
        ) {
            this.setState({
                userRealmState: userRealmStatus.USER_ALREADY_REGISTERED_REALM,
            });
        } else if (
            realms === null &&
            userRealmState !== userRealmStatus.USER_NOT_EXIST
        ) {
            this.setState({ userRealmState: userRealmStatus.USER_NOT_EXIST });
        }

        if (
            showShitchAddRealmForm &&
            !showSearchRealmUserForm &&
            !showNewUserForm &&
            !needShowSwichAddRealm
        ) {
            this.setState({
                needShowForm: false,
                needShowSearchRealms: false,
                needShowSwichAddRealm: true,
                needShowList: false,
            });
        } else if (
            showNewUserForm &&
            !showSearchRealmUserForm &&
            !showShitchAddRealmForm &&
            !needShowForm
        ) {
            this.setState({
                needShowForm: true,
                needShowSearchRealms: false,
                needShowSwichAddRealm: false,
                needShowList: false,
            });
        } else if (
            showSearchRealmUserForm &&
            !showNewUserForm &&
            !showShitchAddRealmForm &&
            !needShowSearchRealms
        ) {
            this.setState({
                needShowForm: false,
                needShowSearchRealms: true,
                needShowSwichAddRealm: false,
                needShowList: false,
            });
        } else if (
            !showSearchRealmUserForm &&
            !showNewUserForm &&
            !showShitchAddRealmForm &&
            !needShowList
        ) {
            this.setState({
                needShowForm: false,
                needShowSearchRealms: false,
                needShowSwichAddRealm: false,
                needShowList: true,
            });
        }
    }

    componentWillUnmount() {
        changeRedirectToUsers({ withNewValue: false });
    }

    clearState() {
        this.setState({ username: '', showFilters: false });
    }

    returnFilterModal() {
        const { username, showFilters } = this.state;
        return (
            <Modal show={showFilters} onClose={this.clearState}>
                <div className="filter-modal">
                    <div className="modal-header">
                        <span>Filtros</span>
                        <i
                            className="fa fa-times"
                            onClick={this.clearState}
                            title="Fechar"
                        />
                    </div>
                    <div className="filter-input-group">
                        <label>Nome</label>
                        <input
                            id="name"
                            value={username}
                            onChange={({ target }) =>
                                this.setState({ username: target.value })
                            }
                        />
                    </div>
                    <div className="modal-footer">
                        <button
                            className="cancel-btn"
                            onClick={this.clearState}
                        >
                            Limpar Filtros
                        </button>
                        <button
                            className="save-btn"
                            onClick={() =>
                                this.setState({ showFilters: false })
                            }
                        >
                            Ok
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }

    closeSearchRealmForm = () => {
        this.props.toggleSearchRealmFormIsVisible(false);
        this.props.clearcheckInfoRealmsUser();
        this.props.clearNewUserForm();
        this.setState({ emailToSearchRealm: '' });
        this.setState({ validCpf: true, validEmail: true });
    };

    closeModalSwitchAddRealm = () => {
        this.props.toggleShitchAddRealmFormIsVisible(false);
        this.props.clearcheckInfoRealmsUser();
        this.props.clearNewUserForm();
        this.setState({ validCpf: true, validEmail: true });
        this.props.toggleSearchRealmFormIsVisible(true);
    };

    closeForm = () => {
        if(this.props.isEditing){
            this.props.changeRedirectToUsers({ withNewValue: true });
        }
        this.props.toggleFormIsVisible(false);
        this.props.clearcheckInfoRealmsUser();
        this.props.clearNewUserForm();
        this.setState({ validCpf: true, validEmail: true });
        this.props.toggleSearchRealmFormIsVisible(true);
    };

    onBlurInput = ({ target }) => {
        if (target.id === 'cpf') {
            this.setState({ validCpf: cpfIsValid(target.value) });
            return true;
        }

        if (target.id === 'email') {
            this.setState({ validEmail: mailIsValid(target.value) });
            return true;
        }
    };

    onChangeUnit = e => {
        const { classes } = this.props;
        this.props.editNewUserInput(e);
        const newClasses = classes.filter(el => el.centerId === e.target.value);
        this.setState(
            {
                classesFiltered: newClasses,
                theresClasses: newClasses.length > 0 ? true : false,
            },
            () => {
                this.props.editNewUserInput({
                    target: { id: 'classId', value: '' },
                });
            },
        );
    };

    saveIsDisabled = editing => {
        const {
            nickname = '',
            email = '',
            classId = '',
            cpf = '',
        } = this.props.newUser;
        const { validCpf } = this.state;

        if (editing) {
            !mailIsValid(email) || nickname === '' ? true : false;
        } else {
            return !mailIsValid(email) ||
                nickname === '' ||
                this.props.newUser.unit_id === '' ||
                classId === '' ||
                cpf === '' ||
                !validCpf ||
                this.state.classesFiltered.length === 0
                ? true
                : false;
        }
    };

    CustomfetchSomeUsers = filter => {
        this.props.fetchSomeUsers(filter);
        this.setState({ filters: filter });
    };

    customFinishEditUser = () => {
        this.props.finishEditUser(success => {
            if (success) {
                this.props.fetchSomeUsers(this.state.filters);
            }
        });
    };

    render() {
        const {
            some: users,
            loading,
            pages,
            all,
            newUser,
            centers,
            waitingForRequest,
            isEditing,
        } = this.props;
        const {
            needShowSwichAddRealm,
            needShowList,
            needShowSearchRealms,
            needShowForm,
            userRealmState,
            emailToSearchRealm,
            initialState
        } = this.state;

        const {
            nickname = '',
            email = '',
            cpf = '',
            classId = '',
            gender = '',
            userId,
        } = newUser;

        return (
            <div className="courses-container users-container">
                <Loader
                    show={waitingForRequest || loading ? true : false}
                    message={
                        loading
                            ? 'Carregando, por favor aguarde...'
                            : 'Enviando dados, aguarde por favor.'
                    }
                />
                {needShowList && (
                    <section
                        onClick={() =>
                            this.props.toggleSearchRealmFormIsVisible(true)
                        }
                        className="add-btn-wrapper"
                        title={'Adicionar novo'}
                    >
                        <i className="fa fa-plus" />
                    </section>
                )}
                {needShowSearchRealms && (
                    <section className="include-user-wrapper">
                        <form
                            onSubmit={ev => ev.preventDefault()}
                            className="include-user-form"
                        >
                            <div className="input-group">
                                <label>*Email:</label>
                                <input
                                    id="emailToSearchRealm"
                                    onChange={ev =>
                                        this.setState({
                                            emailToSearchRealm: ev.target.value,
                                        })
                                    }
                                    value={emailToSearchRealm}
                                    type={'email'}
                                    placeholder="Ex: email@exemplo.com"
                                />
                            </div>
                        </form>
                        <footer className="include-user-footer">
                            <article>
                                Os campos marcados com (*) são obrigatórios.
                            </article>
                            <section>
                                <button
                                    type="button"
                                    onClick={this.closeSearchRealmForm}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    disabled={!emailToSearchRealm}
                                    onClick={() => {
                                        this.props.checkInfoRealmsUser({
                                            email: emailToSearchRealm,
                                        });
                                    }}
                                >
                                    Continuar
                                </button>
                            </section>
                        </footer>
                    </section>
                )}
                {needShowSwichAddRealm &&
                    userRealmState ===
                        userRealmStatus.USER_READY_TO_REGISTER_REALM && (
                        <section className="include-user-wrapper">
                            <p className="question-realms">
                                O usuário existe, mas ainda não está adicionado
                                a qualquer turma do EAD. Deseja adicioná-lo a
                                uma turma?
                            </p>
                            <footer className="include-user-footer only-buttons-footer">
                                <section>
                                    <button
                                        onClick={this.closeModalSwitchAddRealm}
                                    >
                                        Não
                                    </button>
                                    <button
                                        onClick={() => {
                                            this.props.toggleShitchAddRealmFormIsVisible(
                                                false,
                                            );
                                            this.props.toggleFormIsVisible(
                                                true,
                                            );
                                        }}
                                    >
                                        Sim
                                    </button>
                                </section>
                            </footer>
                        </section>
                    )}
                {needShowForm && (
                    <section className="include-user-wrapper">
                        <form className="include-user-form">
                            <div className="input-group">
                                <label>*Nome:</label>
                                <input
                                    disabled={
                                        userRealmState ===
                                        userRealmStatus.USER_READY_TO_REGISTER_REALM &&  initialState.nickname
                                    }
                                    maxLength={100}
                                    id="nickname"
                                    onChange={this.props.editNewUserInput}
                                    value={nickname}
                                    type={'text'}
                                    placeholder="Ex: Marcos henrique"
                                />
                            </div>
                            <div className="input-group">
                                <label>*Email:</label>
                                <input
                                    disabled={
                                        isEditing ||
                                        userRealmState ===
                                            userRealmStatus.USER_READY_TO_REGISTER_REALM && initialState.email
                                            ? true
                                            : false
                                    }
                                    onBlur={this.onBlurInput}
                                    id="email"
                                    onChange={this.props.editNewUserInput}
                                    value={email}
                                    type="email"
                                    placeholder="Ex: email@exemplo.com"
                                />
                                <small
                                    className={
                                        !this.state.validEmail ? 'show' : ''
                                    }
                                >
                                    Email inválido
                                </small>
                            </div>
                            <div className="input-group">
                                <label>Telefone:</label>
                                <PhoneInput
                                    disabled={
                                        userRealmState ===
                                        userRealmStatus.USER_READY_TO_REGISTER_REALM && initialState.phone_number
                                            ? true
                                            : false
                                    }
                                    placeholder="Informe seu número"
                                    value={newUser.phone_number || ''}
                                    onChange={value =>
                                        this.props.editNewUserInput({
                                            target: {
                                                value,
                                                id: 'phone_number',
                                            },
                                        })
                                    }
                                />
                                <small
                                    className={
                                        typeof newUser.phone_number !==
                                            'undefined' &&
                                        newUser.phone_number !== null &&
                                        !isValidPhoneNumber(
                                            this.props.newUser.phone_number ||
                                                '',
                                        )
                                            ? 'show'
                                            : ''
                                    }
                                >
                                    Telefone inválido
                                </small>
                            </div>
                            <div className="input-group">
                                <label>*CPF:</label>
                                <MaskedInput
                                    disabled={
                                        userRealmState ===
                                        userRealmStatus.USER_READY_TO_REGISTER_REALM && initialState.cpf
                                    }
                                    mask={'999.999.999-99'}
                                    onBlur={this.onBlurInput}
                                    id="cpf"
                                    onChange={this.props.editNewUserInput}
                                    value={cpf}
                                    placeholder="Ex: 999.999.999-99"
                                />
                                <small
                                    className={
                                        !this.state.validCpf ? 'show' : ''
                                    }
                                >
                                    CPF inválido
                                </small>
                            </div>
                            <div className="input-group">
                                <label>Sexo:</label>
                                <select
                                    disabled={
                                        userRealmState ===
                                        userRealmStatus.USER_READY_TO_REGISTER_REALM && initialState.gender
                                    }
                                    id="gender"
                                    onChange={this.props.editNewUserInput}
                                    value={gender}
                                >
                                    <option value="">
                                        Selecione um gênero:
                                    </option>
                                    <option value={'male'}>Masculino</option>
                                    <option value={'female'}>Feminino</option>
                                </select>
                            </div>
                            {!isEditing && (
                                <div className="input-group">
                                    <label>*Unidade:</label>
                                    <select
                                        disabled={isEditing ? true : false}
                                        id="unit_id"
                                        onChange={this.onChangeUnit}
                                        value={newUser.unit_id}
                                    >
                                        <option value="">
                                            Selecione uma unidade:
                                        </option>
                                        {centers.map(c => (
                                            <option key={c.id} value={c.id}>{`${
                                                c.name
                                            }${
                                                c.state ? ` - ${c.state}` : ''
                                            }, ${c.country}`}</option>
                                        ))}
                                    </select>
                                    <small
                                        className={
                                            !this.state.theresClasses
                                                ? 'show'
                                                : ''
                                        }
                                    >
                                        Unidade não possui turmas cadastradas
                                    </small>
                                </div>
                            )}
                            {!isEditing && (
                                <div className="input-group">
                                    <label>*Turma:</label>
                                    <select
                                        disabled={
                                            newUser.unit_id === '' ||
                                            this.state.classesFiltered
                                                .length === 0
                                                ? true
                                                : false
                                        }
                                        id="classId"
                                        onChange={this.props.editNewUserInput}
                                        value={classId}
                                    >
                                        <option value="">
                                            Selecione uma turma:
                                        </option>
                                        {this.state.classesFiltered.map(
                                            (c, i) => (
                                                <option
                                                    key={i}
                                                    value={c.classId}
                                                >
                                                    {c.className}
                                                </option>
                                            ),
                                        )}
                                    </select>
                                </div>
                            )}
                        </form>
                        <footer className="include-user-footer">
                            <article>
                                Os campos marcados com (*) são obrigatórios.
                            </article>
                            <section>
                                <button onClick={this.closeForm}>Voltar</button>
                                <button
                                    disabled={this.saveIsDisabled(isEditing)}
                                    onClick={
                                        userRealmState ===
                                        userRealmStatus.USER_READY_TO_REGISTER_REALM
                                            ? () => {
                                                  this.props.enrollUserFromRegisterNewUser(
                                                      {
                                                          classId: classId,
                                                          userId: userId,
                                                      },
                                                  );
                                              }
                                            : isEditing
                                            ? this.customFinishEditUser
                                            : this.props.createNewUser
                                    }
                                >
                                    Salvar
                                </button>
                            </section>
                        </footer>
                    </section>
                )}
                {needShowList && (
                    <DataTable
                        className="users-table"
                        data={users}
                        pages={pages}
                        allData={all}
                        columns={COLUMNS}
                        defaultSorted={[{ id: 'name' }]}
                        exportName={`usuários-${moment().toISOString()}.csv`}
                        manual
                        fetchMethod={this.CustomfetchSomeUsers}
                        fetchAllMethod={this.props.fetchUsers}
                    />
                )}
            </div>
        );
    }
}

class ActionsGroup extends React.Component {
    state = {
        showEnrollmentModal: false,
        showExtendsModal: false,
        addFiles: false,
        showAttachments: false,
    };

    render() {
        let enrollmentWithName = [...this.props.users.enrollments];
        enrollmentWithName = enrollmentWithName.map(e => {
            this.props.classes.forEach(el => {
                if (el.classId === e.classId) {
                    e.className = el.className;
                }
            });
            return e;
        });

        return (
            <div className="actions-row">
                <button
                    title="Matrículas"
                    onClick={() => this.setState({ showEnrollmentModal: true })}
                >
                    <i className="fa fa-address-card-o" />
                </button>

                <button
                    title="Editar Usuário"
                    onClick={() => this.props.initEditUser(this.props.original)}
                >
                    <i className="fa fa-pencil" />
                </button>
                <button
                    title="Enviar Anexos"
                    onClick={() => this.setState({ addFiles: true })}
                >
                    <i className="fa fa-cloud-upload" />
                </button>
                <button
                    title="Listar Anexos"
                    onClick={() => this.setState({ showAttachments: true })}
                >
                    <i className="fa fa-files-o" />
                </button>
                <button
                    title="Estender Prazo"
                    onClick={() => this.setState({ showExtendsModal: true })}
                >
                    <i className="fa fa fa-clock-o" />
                </button>
                {this.state.addFiles && (
                    <SubmitFiles
                        onClose={() => this.setState({ addFiles: false })}
                        enrollments={enrollmentWithName}
                        fetchUserEnrollments={this.props.fetchUserEnrollments}
                        loading={this.props.users.loading}
                        user={this.props.original}
                        uploadAttach={this.props.uploadAttach}
                        createAlert={this.props.createAlertFunc}
                    />
                )}
                {this.state.showAttachments && (
                    <AtachmentsModal
                        onClose={() =>
                            this.setState({ showAttachments: false })
                        }
                        enrollments={enrollmentWithName}
                        fetchUserEnrollments={this.props.fetchUserEnrollments}
                        loading={this.props.users.loading}
                        user={this.props.original}
                        attachmentClassChoose={this.props.attachmentClassChoose}
                        downloadAttach={this.props.downloadAttach}
                        deletingAttach={this.props.deletingAttach}
                    />
                )}
                {this.state.showExtendsModal && (
                    <ExtendsModal
                        onClose={() =>
                            this.setState({ showExtendsModal: false })
                        }
                        enrollments={enrollmentWithName}
                        fetchUserEnrollments={this.props.fetchUserEnrollments}
                        classes={this.props.classes}
                        updateEnrollment={this.props.updateEnrollment}
                        user={this.props.original}
                        loading={this.props.users.loading}
                    />
                )}
                {this.state.showEnrollmentModal && (
                    <EnrollmentModal
                        onClose={() =>
                            this.setState({ showEnrollmentModal: false })
                        }
                        classes={this.props.classes}
                        user={this.props.original}
                        enrollments={this.props.users.enrollments}
                        enrollUser={this.props.enrollUser}
                        unenrollUser={this.props.unenrollUser}
                        fetchUserEnrollments={this.props.fetchUserEnrollments}
                        loading={this.props.users.loading}
                    />
                )}
            </div>
        );
    }
}

const ActionsCell = connect(
    ({ classes, users }) => ({ classes: classes.data, users }),
    dispatch =>
        bindActionCreators(
            {
                enrollUser,
                unenrollUser,
                updateEnrollment,
                fetchUserEnrollments,
                uploadAttach,
                attachmentClassChoose,
                downloadAttach,
                deletingAttach,
                initEditUser,
                createAlertFunc,
            },
            dispatch,
        ),
)(ActionsGroup);

class ExtendsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            enrollments: [],
            errorMsg: '',
            selectedEnrollment: '',
        };
        this.setCurrentEnrollment = this.setCurrentEnrollment.bind(this);
        this.returnEnrollments = this.returnEnrollments.bind(this);
        this.renderSelectoptions = this.renderSelectoptions.bind(this);
    }

    componentDidMount() {
        this.props.fetchUserEnrollments(this.props.user.userId);
    }

    componentWillReceiveProps(newProps) {
        if (this.state.enrollments !== newProps.enrollments) {
            this.setState({ enrollments: [...newProps.enrollments] });
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        const toUpdate = this.state.enrollments.filter(
            e => !this.props.enrollments.includes(e),
        );
        toUpdate.forEach(u =>
            this.props.updateEnrollment(u.classId, u.userId, {
                extension: u.extension,
                eadEndDate: u.eadEndDate,
            }),
        );
        this.props.onClose();
    };

    handleChange = (date, enrollment, name, idx) => {
        const data =
            name === 'extension'
                ? date
                      .endOf('d')
                      .diff(
                          moment(
                              this.classEndDateById(enrollment.classId),
                          ).endOf('d'),
                          'd',
                      )
                : date.toISOString();

        const updatedEnrollments = this.state.enrollments;
        updatedEnrollments[idx] = { ...enrollment, [name]: data };
        this.setState({ enrollments: updatedEnrollments });
    };

    handleCancel = e => {
        e.preventDefault();
        this.props.onClose();
    };

    classNameById = classId => {
        const itsClass =
            this.props.classes.find(c => c.classId === classId) || {};
        return itsClass.className;
    };

    classEndDateById = classId => {
        const itsClass =
            this.props.classes.find(c => c.classId === classId) || {};
        return itsClass.endDate;
    };

    dpSelected = (classId, extension) => {
        const classEnd = this.classEndDateById(classId);
        return extension >= 0 && classEnd
            ? moment(classEnd).endOf('d').add(extension, 'd')
            : null;
    };

    eadMaxDate = (classId, extension) =>
        this.classEndDateById(classId)
            ? moment(this.classEndDateById(classId))
                  .endOf('d')
                  .add(extension || 0, 'd')
            : null;

    renderSelectoptions(array) {
        const newArray = [...array];
        return newArray.map((e, i) => {
            return (
                <option
                    key={i}
                    value={e.classId}
                >{`${e.classId} / ${e.className}`}</option>
            );
        });
    }

    setCurrentEnrollment({ target }) {
        this.setState({ selectedEnrollment: target.value });
    }

    returnEnrollments(array, id) {
        const newArray = [...array];
        return newArray.map((e, idx) => {
            if (e.classId === id) {
                return (
                    <fieldset className="extend-class input-set" key={idx}>
                        <legend>{`${
                            this.classNameById(e.classId) ||
                            `${e.classId} - REMOVIDA`
                        }`}</legend>
                        <div className="inputs-wrapper">
                            <div className="inline-form-row">
                                <label>Extensão turma:</label>
                                <DatePicker
                                    readOnly
                                    minDate={
                                        moment(
                                            this.classEndDateById(e.classId),
                                        ) || null
                                    }
                                    selected={this.dpSelected(
                                        e.classId,
                                        e.extension,
                                    )}
                                    disabled={
                                        !this.classNameById(e.classId) ||
                                        !this.classEndDateById(e.classId)
                                    }
                                    onChange={date =>
                                        this.handleChange(
                                            date,
                                            e,
                                            'extension',
                                            idx,
                                        )
                                    }
                                />
                            </div>
                        </div>
                    </fieldset>
                );
            } else {
                return null;
            }
        });
    }

    render() {
        const { loading } = this.props;
        const { enrollments, selectedEnrollment } = this.state;
        return (
            <Modal
                show={true}
                {...this.props}
                overlayStyle={{ opacity: loading ? 0 : 1 }}
            >
                <div className="enrollment-modal">
                    {loading ? (
                        <div style={{ display: 'none' }} />
                    ) : enrollments.length ? (
                        <div className="extend-container">
                            <div className="select-wrapper">
                                <select
                                    value={
                                        selectedEnrollment
                                            ? selectedEnrollment
                                            : '-1'
                                    }
                                    onChange={this.setCurrentEnrollment}
                                >
                                    <option value="-1">
                                        Escolha sua turma
                                    </option>
                                    {this.renderSelectoptions(enrollments)}
                                </select>
                            </div>
                            <form onSubmit={this.handleSubmit}>
                                {this.returnEnrollments(
                                    enrollments,
                                    selectedEnrollment,
                                )}
                                <div className="modal-footer">
                                    <button
                                        className="cancel-btn"
                                        onClick={this.handleCancel}
                                    >
                                        Cancelar
                                    </button>
                                    <button className="save-btn" type="submit">
                                        Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <React.Fragment>
                            <div className="modal-header">
                                <span>O usuário não possui matrículas</span>
                                <i
                                    className="fa fa-times"
                                    onClick={this.handleCancel}
                                    title="Fechar"
                                />
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </Modal>
        );
    }
}

class AtachmentsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            attachments: [],
            enrollments: [],
            selectedEnrollment: '-1',
            searchingAttachments: false,
            deletingId: null,
        };
    }

    componentDidMount() {
        this.props.fetchUserEnrollments(this.props.user.userId);
    }

    componentWillReceiveProps(newProps) {
        if (this.state.enrollments !== newProps.enrollments) {
            this.setState({ enrollments: [...newProps.enrollments] });
        }
    }

    renderSelectoptions = array => {
        const newArray = [...array];
        return newArray.map((e, i) => {
            return (
                <option
                    key={i}
                    value={e.classId}
                >{`${e.classId} / ${e.className}`}</option>
            );
        });
    };

    setCurrentEnrollment = ({ target }) => {
        if (target.value === '-1') {
            this.setState({ selectedEnrollment: target.value });
        } else {
            this.setState(
                {
                    searchingAttachments: true,
                    selectedEnrollment: target.value,
                },
                () => {
                    this.props.attachmentClassChoose(
                        this.props.user.userId,
                        this.state.selectedEnrollment,
                        data =>
                            this.setState({
                                attachments: data,
                                searchingAttachments: false,
                            }),
                    );
                },
            );
        }
    };

    downloadingAttach = id => {
        this.setState({ downloadingAttach: true });
        this.props.downloadAttach(
            this.props.user.userId,
            this.state.selectedEnrollment,
            id,
            () => this.setState({ downloadingAttach: false }),
        );
    };

    showModalDelete = id => {
        this.setState({ deletingId: id });
    };

    cancelDelete = e => {
        e.preventDefault();
        this.setState({ deletingId: false });
    };

    deleteAttach = id => {
        this.setState({ deletingAttach: true });
        this.props.deletingAttach(
            this.props.user.userId,
            this.state.selectedEnrollment,
            id,
            success => {
                this.setState({ deletingAttach: false });
                if (success) {
                    this.setState({ searchingAttachments: true }, () => {
                        this.props.attachmentClassChoose(
                            this.props.user.userId,
                            this.state.selectedEnrollment,
                            data =>
                                this.setState({
                                    attachments: data,
                                    searchingAttachments: false,
                                }),
                        );
                    });
                }
            },
        );
    };

    renderAttachs = (data = []) => {
        const { deletingId, deletingAttach } = this.state;
        return data.map((e, i) => (
            <div className="attach-wrapper" key={e.id}>
                <section
                    key={i}
                    className="unstyled"
                    onClick={() => this.downloadingAttach(e.id)}
                >
                    <span>{e.title}</span>
                </section>

                <section
                    className={`delete-section ${
                        deletingId === e.id ? 'deleting' : ''
                    }`}
                    title="Deletar"
                >
                    <div onClick={() => this.showModalDelete(e.id)}>
                        <i className="fa fa-trash" />
                    </div>

                    <section className="confirm-delete-dialog">
                        <h5>
                            <i className="fa fa-trash" />
                            &nbsp;{`Deseja remover ${e.title} ?`}
                        </h5>
                        <div className="btn-delete-wrapper">
                            <button
                                disabled={deletingAttach ? true : false}
                                onClick={this.cancelDelete}
                            >
                                Cancelar
                            </button>
                            <button
                                disabled={deletingAttach ? true : false}
                                onClick={() => this.deleteAttach(e.id)}
                            >
                                {deletingAttach ? (
                                    <i className="fa fa-spin fa-circle-o-notch" />
                                ) : (
                                    ''
                                )}
                                {deletingAttach ? '  Deletando...' : 'Remover'}
                            </button>
                        </div>
                    </section>
                </section>
            </div>
        ));
    };

    renderBodyModal = (attachments, loading, downloadingInProgress) => {
        if (loading) {
            return null;
        }

        return (
            <div className={'attachments-body user-upload show-attachs'}>
                <section
                    className={`${
                        !downloadingInProgress ? 'hidden-upload' : 'show-upload'
                    }`}
                >
                    <section className={'icons-wrapper'}>
                        <i className="fa fa-cloud" />
                        <i className="fa fa-arrow-down arrow-animated-down" />
                    </section>
                    <section className="text-wrapper">
                        <h5>Preparando download...</h5>
                    </section>
                </section>

                <section
                    className={`${
                        downloadingInProgress ? 'hidden-upload' : 'show-upload'
                    }`}
                >
                    <div className="modal-header">
                        <span>Anexos</span>
                        <i
                            className="fa fa-times"
                            onClick={this.handleCancel}
                            title="Fechar"
                        />
                    </div>
                    <div className="inline-form-row">
                        <label>Turma:</label>
                        <select
                            value={
                                this.state.selectedEnrollment
                                    ? this.state.selectedEnrollment
                                    : '-1'
                            }
                            onChange={this.setCurrentEnrollment}
                        >
                            <option value="-1">Escolha sua turma</option>
                            {this.renderSelectoptions(this.state.enrollments)}
                        </select>
                    </div>
                    {this.state.selectedEnrollment !== '-1' &&
                        this.state.selectedEnrollment !== '' && (
                            <React.Fragment>
                                {this.state.searchingAttachments && (
                                    <section className="no-class-selected">
                                        <div className="icons-wrapper-div">
                                            <i className="fa fa-hourglass-start" />
                                            <i className="fa fa-hourglass-half" />
                                            <i className="fa fa-hourglass-end" />
                                        </div>
                                        <h3> Procurando anexos...</h3>
                                    </section>
                                )}
                                {!this.state.searchingAttachments &&
                                    this.state.attachments.length === 0 && (
                                        <section className="no-class-selected">
                                            <i className="fa fa-thumbs-o-down" />
                                            <h3>Turma sem anexos </h3>
                                        </section>
                                    )}
                                {!this.state.searchingAttachments &&
                                    this.state.attachments.length > 0 && (
                                        <React.Fragment>
                                            {this.renderAttachs(attachments)}
                                        </React.Fragment>
                                    )}
                            </React.Fragment>
                        )}
                    {this.state.selectedEnrollment === '-1' && (
                        <section className="no-class-selected">
                            <i className="fa fa-hand-pointer-o" />
                            <h3>Você precisa escolher uma turma </h3>
                        </section>
                    )}
                </section>
            </div>
        );
    };

    handleCancel = e => {
        e.preventDefault();
        this.props.onClose();
    };

    render() {
        const { attachments, downloadingAttach } = this.state;
        const { loading } = this.props;

        return (
            <Modal
                show={true}
                {...this.props}
                overlayStyle={{ opacity: loading ? 0 : 1 }}
            >
                {this.renderBodyModal(attachments, loading, downloadingAttach)}
            </Modal>
        );
    }
}

class SubmitFiles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: true,
            enrollments: [],
            errorMsg: '',
            selectedEnrollment: '',
            uploading: false,
            title: '',
        };
    }

    componentDidMount() {
        this.props.fetchUserEnrollments(this.props.user.userId);
    }

    componentWillReceiveProps(newProps) {
        if (this.state.enrollments !== newProps.enrollments) {
            this.setState({ enrollments: [...newProps.enrollments] });
        }
    }

    handleCancel = e => {
        e.preventDefault();
        this.props.onClose();
    };

    renderSelectoptions = array => {
        const newArray = [...array];
        return newArray.map((e, i) => {
            return (
                <option
                    key={i}
                    value={e.classId}
                >{`${e.classId} / ${e.className}`}</option>
            );
        });
    };

    setCurrentEnrollment = ({ target }) => {
        this.setState({ selectedEnrollment: target.value });
    };

    onChange = ({ target }) => {
        if (target.value.size > 10000000) {
            this.setState({ [target.name]: null }, () => {
                this.props.createAlert(
                    'error',
                    'Limite de tamanho excedido',
                    'Tamanho máximo de arquivo é 10 MB, por favor escolha um outro arquivo.',
                    5000,
                );
            });
        } else {
            this.setState({ [target.name]: target.value });
        }
    };

    submitAttachment = async e => {
        e.preventDefault();
        this.setState({ uploading: true });
        const fileAsArrayBuffer = await readFile(this.state.file);

        this.props.uploadAttach(
            fileAsArrayBuffer,
            this.state.title !== '' ? this.state.title : this.state.file.name,
            this.state.file.type,
            this.props.user.userId,
            this.state.selectedEnrollment,
            success => {
                if (success) {
                    this.setState({
                        uploading: false,
                        selectedEnrollment: '',
                        file: null,
                        title: '',
                    });
                } else {
                    this.setState({ uploading: false });
                }
            },
        );
    };

    render() {
        const { enrollments, selectedEnrollment, uploading } = this.state;
        const { loading } = this.props;

        return (
            <Modal
                show={true}
                {...this.props}
                overlayStyle={{ opacity: loading ? 0 : 1 }}
            >
                <div className={'new-class-modal'}>
                    <React.Fragment>
                        <section
                            className={`${
                                uploading ? 'show-upload' : 'hidden-upload'
                            }`}
                        >
                            <section className={'icons-wrapper'}>
                                <i className="fa fa-cloud" />
                                <i className="fa fa-arrow-up arrow-animated" />
                            </section>
                            <section className="text-wrapper">
                                <h5>Uploading...</h5>
                            </section>
                        </section>
                        {enrollments.length ? (
                            <section
                                className={`${
                                    uploading ? 'hidden-upload' : 'show-upload'
                                }`}
                            >
                                <h4>Adicionar anexo</h4>
                                <form onSubmit={this.handleSubmit}>
                                    <div className="new-class-modal-fields">
                                        <div className="inline-form-row">
                                            <label>Turma:</label>
                                            <select
                                                value={
                                                    selectedEnrollment
                                                        ? selectedEnrollment
                                                        : '-1'
                                                }
                                                onChange={
                                                    this.setCurrentEnrollment
                                                }
                                            >
                                                <option value="-1">
                                                    Escolha sua turma
                                                </option>
                                                {this.renderSelectoptions(
                                                    enrollments,
                                                )}
                                            </select>
                                        </div>
                                        <div className="inline-form-row">
                                            <label>Título</label>
                                            <input
                                                onChange={this.onChange}
                                                name="title"
                                                value={this.state.title}
                                                placeholder="Título"
                                            />
                                        </div>
                                        <div className="inline-form-row">
                                            <label>Arquivo</label>
                                            {this.state.file && (
                                                <span
                                                    style={{
                                                        color: '#1da4fc',
                                                        marginBottom: '10px',
                                                    }}
                                                >
                                                    {this.state.file.name}
                                                </span>
                                            )}
                                            {
                                                <SelectFile
                                                    accept={
                                                        'image/*,.pdf,audio/*,video/*'
                                                    }
                                                    onChange={file =>
                                                        this.onChange({
                                                            target: {
                                                                name: 'file',
                                                                value: file,
                                                            },
                                                        })
                                                    }
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className="new-class-modal-btns">
                                        <button onClick={this.handleCancel}>
                                            Cancelar
                                        </button>
                                        <button
                                            onClick={this.submitAttachment}
                                            type="submit"
                                            disabled={
                                                selectedEnrollment === '' ||
                                                selectedEnrollment === '-1' ||
                                                !this.state.file
                                            }
                                        >
                                            Adicionar
                                        </button>
                                    </div>
                                </form>
                            </section>
                        ) : (
                            <React.Fragment>
                                <div className="modal-header add-file">
                                    <span>O usuário não possui matrículas</span>
                                    <i
                                        className="fa fa-times"
                                        onClick={this.handleCancel}
                                        title="Fechar"
                                    />
                                </div>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                </div>
            </Modal>
        );
    }
}

class EnrollmentModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: [],
            valueToNotify: [],
            showAdvice: false,
        };

        this.checkValuesAfterSet = this.checkValuesAfterSet.bind(this);
        this.cancelConfirmModal = this.cancelConfirmModal.bind(this);
        this.confirmModalAction = this.confirmModalAction.bind(this);
    }

    componentDidMount() {
        this.props.fetchUserEnrollments(this.props.user.userId);
    }

    componentWillReceiveProps(newProps) {
        const value = newProps.enrollments.map(e => e.classId);
        if (this.state.value !== value) {
            this.setState({ value });
        }
    }

    handleCancel = e => {
        e.preventDefault();
        this.props.onClose();
    };

    handleSubmit = e => {
        e.preventDefault();
        const { enrollments, user, unenrollUser, enrollUser } = this.props;
        const currentUserId = user.userId;
        const thisUserEnrollments = enrollments.filter(
            r => r.userId === currentUserId,
        );
        const toUnenroll = thisUserEnrollments.reduce(
            (result, item) =>
                !this.state.value.includes(item.classId)
                    ? [...result, item.classId]
                    : [...result],
            [],
        );

        const toEnroll = this.state.value.filter(
            item => !thisUserEnrollments.find(r => r.classId === item),
        );

        if (toUnenroll && toUnenroll.length !== 0) {
            unenrollUser({ classId: toUnenroll, userId: currentUserId });
        }

        if (toEnroll && toEnroll.length !== 0) {
            enrollUser({ classId: toEnroll, userId: currentUserId });
        }

        this.props.onClose();
    };

    checkValuesAfterSet(value) {
        let difference = this.state.value.filter(x => !value.includes(x));
        if (difference.length > 0) {
            this.setState({ showAdvice: true, valueToNotify: value });
        } else {
            this.setState({ value });
        }
    }

    cancelConfirmModal() {
        this.setState({ valueToNotify: [], showAdvice: false });
    }

    confirmModalAction() {
        this.setState(
            { value: this.state.valueToNotify, showAdvice: false },
            () => {
                this.setState({ valueToNotify: [] });
            },
        );
    }

    render() {
        const { classes, loading, user } = this.props;
        const options = classes.map(c => ({
            value: c.classId,
            label: isExpired(c) ? `${c.className}*` : c.className,
        }));
        this.state.value.forEach(val => {
            if (!classes.find(c => c.classId === val)) {
                options.push({ value: val, label: `${val} - REMOVIDA` });
            }
        });

        const { showAdvice } = this.state;
        const msg = (
            <div>
                <h3 style={{ color: 'red', textTransform: 'uppercase' }}>
                    Atenção !
                </h3>
                <p>
                    {' '}
                    Ao cancelar a matrícula, todos os dados do aluno (tcc,
                    anexos e etc...) serão removidos.
                </p>
                <br />
                <p>Deseja realmente cancelar a matrícula?</p>
            </div>
        );
        return (
            <Modal
                show={true}
                {...this.props}
                overlayStyle={{ opacity: loading ? 0 : 1 }}
            >
                <div className="registry-modal">
                    <ConfirmationModal
                        bodyClass="advice-body"
                        show={showAdvice}
                        onClose={this.cancelConfirmModal}
                        onCancel={this.cancelConfirmModal}
                        onConfirm={this.confirmModalAction}
                        msg={msg}
                    />
                    {loading ? (
                        <div />
                    ) : (
                        <div className="modal-registry-body">
                            <div className="modal-header">
                                <div className="title">
                                    Gerenciar Matrículas - {user.name}
                                </div>
                                <i
                                    className="fa fa-times"
                                    onClick={this.handleCancel}
                                    title="Fechar"
                                />
                            </div>
                            <form onSubmit={this.handleSubmit}>
                                <MultiSelect
                                    placeholder="Buscar"
                                    searchable={true}
                                    onChange={this.checkValuesAfterSet}
                                    availableHeader="Disponíveis"
                                    selectedHeader="Matriculadas"
                                    options={options}
                                    value={this.state.value}
                                />
                                <div className="enrollment-modal-sub-info">
                                    <div>* turma expirada</div>
                                </div>
                                <div className="registry-modal-btns">
                                    <button onClick={this.handleCancel}>
                                        Cancelar
                                    </button>
                                    <button type="submit">Salvar</button>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </Modal>
        );
    }
}

export default connect(
    ({ users, classes, centers }) => ({
        ...users,
        classes: classes.data,
        centers: centers,
    }),
    dispatch =>
        bindActionCreators(
            {
                enrollUserFromRegisterNewUser,
                fetchSomeUsers,
                fetchUsers,
                editNewUserInput,
                toggleFormIsVisible,
                toggleSearchRealmFormIsVisible,
                toggleShitchAddRealmFormIsVisible,
                checkInfoRealmsUser,
                clearcheckInfoRealmsUser,
                clearNewUserForm,
                createNewUser,
                finishEditUser,
                changeRedirectToUsers,
            },
            dispatch,
        ),
)(Users);

const COLUMNS = [
    { Header: 'Nome', accessor: 'name' },
    { Header: 'e-mail', accessor: 'email' },
    {
        Header: 'Ações',
        exportable: false,
        Cell: props => <ActionsCell {...props} />,
        sortable: false,
    },
];

function isExpired(aClass) {
    return aClass.endDate && moment(moment()).isAfter(aClass.endDate);
}



// WEBPACK FOOTER //
// ./src/components/users/users.js